import React, { memo, useCallback, useState } from "react";
import styles from "./styles.module.scss";
import FileUpload from "app/components/FileUpload";
import { useTranslation } from "react-i18next";
import { PostMedia } from "app/components/paywalls";
import { MediaModel } from "app/models";
import { cls } from "app/utils";

interface Props {
  hideUploadBtn?: boolean;
  canSelectMedia?: boolean;
  hasPermission?: boolean;
  onSelectMedia?: (media?: MediaModel[]) => void;
  hasMultiSelect?: boolean;
  alreadySelected?: MediaModel[];
}

const AddMoreMedia = ({
  hideUploadBtn,
  canSelectMedia = true,
  hasPermission = false,
  onSelectMedia,
  hasMultiSelect,
  alreadySelected
}: Props) => {
  const { t } = useTranslation();
  const onClose = () => {
    setModalIsOpen(false);
  };
  const [showPaywallModal, setShowPaywallModal] = useState(false);
  const [isModalOpen, setModalIsOpen] = useState(false);

  const onUpgrade = () => {
    onClose();
    setShowPaywallModal(true);
  };

  const closePaywall = useCallback(() => {
    setShowPaywallModal(false);
  }, []);

  const onModalOpen = () => {
    if (hasPermission) {
      setModalIsOpen(true);
    } else {
      return onUpgrade();
    }
  };

  return (
    <>
      <div className={styles.content_wrapper}>
        {!hideUploadBtn && (
          <div className={styles.add_more_button_wrapper} onClick={onModalOpen}>
          <i className={cls("ico ico-add", styles.plus_icon)} />
          <p className={styles.add_more_text}>{t("Add More")}</p>
        </div>
        )}
      </div>
      {isModalOpen && (
        <FileUpload
          isOpen={isModalOpen}
          onClose={onClose}
          canSelectMedia={canSelectMedia}
          onSelectMedia={onSelectMedia}
          hasMultiSelect={hasMultiSelect}
          alreadySelected={alreadySelected}
        />
      )}
      <PostMedia show={showPaywallModal} onClose={closePaywall} />
    </>
  );
};

export default memo(AddMoreMedia);
